import Vue from 'vue';
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');

Object.defineProperties(Vue.prototype, {
  $moment: {
    get() {
      return moment;
    },
  },
});

// Vue.prototype.$moment = moment;
